import type { ColumnAnnotation, Proposal } from '@/services/api/structuredIngest'

export function textExtractionColumns(recipe: Proposal): ColumnAnnotation[] {
  const holders = new Set(
    [...(recipe.entity_descriptors ?? []), ...(recipe.subject_entities ?? [])]
      .filter(entity => entity.enabled !== false)
      .map(entity => entity.name)
  )
  return (recipe.columns ?? []).filter(
    column =>
      column.role === 'text' &&
      !!column.entity &&
      holders.has(column.entity) &&
      !!(column.property || column.alias)
  )
}

export function withTextExtraction(
  recipe: Proposal,
  column: ColumnAnnotation,
  enabled: boolean
): Proposal {
  return {
    ...recipe,
    columns: (recipe.columns ?? []).map(current =>
      current.name === column.name && current.entity === column.entity
        ? { ...current, extract_entities: enabled }
        : current
    ),
  }
}

export function withRowTextExtraction(
  recipe: Proposal,
  column: string,
  enabled: boolean
): Proposal {
  const selected = new Set(recipe.row_text_columns ?? [])
  if (enabled) selected.add(column)
  else selected.delete(column)
  return { ...recipe, row_text_columns: [...selected] }
}

export function hasTextExtraction(recipe: Proposal): boolean {
  return (
    !!recipe.row_text_columns?.length ||
    textExtractionColumns(recipe).some(column => column.extract_entities === true)
  )
}
